import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InstitutionWelcomeComponent, InstitutionWelcomeDialog, SubscriptionComponent, SubscriptionSampleDialog, SubscriptionEmailDialog } from './institution.component';

@NgModule({
	imports: [
		CommonModule,
		FormsModule
	],
	declarations: [
		InstitutionWelcomeComponent,
		InstitutionWelcomeDialog,
		SubscriptionComponent,
		SubscriptionSampleDialog,
		SubscriptionEmailDialog
	],
	exports: [
		InstitutionWelcomeComponent,
		InstitutionWelcomeDialog,
		SubscriptionComponent,
		SubscriptionSampleDialog,
		SubscriptionEmailDialog
	]
})
export class InstitutionComponentModule { }
